/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Study_Field_LabelInputs */

const en_company_profile_study_field_label = /** @type {(inputs: Company_Profile_Study_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferred field of study`)
};

const de_company_profile_study_field_label = /** @type {(inputs: Company_Profile_Study_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorzugtes Studienfeld`)
};

/**
* | output |
* | --- |
* | "Preferred field of study" |
*
* @param {Company_Profile_Study_Field_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_study_field_label = /** @type {((inputs?: Company_Profile_Study_Field_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Study_Field_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_study_field_label(inputs)
	return en_company_profile_study_field_label(inputs)
});